/**
 * Snippet Category Constants
 *
 * Defines the available category filter IDs for snippets. Category labels
 * are provided by useSnippetFilterCategories. Categories are used by the
 * SnippetTabContent component and the useSnippetFilterAndSort hook.
 *
 * Category filtering logic:
 * - ALL: Shows all snippets (no filtering)
 * - MY_TEMPLATES: Shows only snippets created by the current user
 * - FAVORITES: Shows only snippets marked as favorites
 */

/** Constant IDs for snippet category filters - used as keys in state and filter logic */
export enum SNIPPET_CATEGORY_IDS {
	ALL = 'snippets.all',
	MY_TEMPLATES = 'snippets.my-templates',
	FAVORITES = 'snippets.favorites',
}

/** The default category shown when the filter UI first loads */
export const DEFAULT_CATEGORY_ID: SNIPPET_CATEGORY_IDS.ALL = SNIPPET_CATEGORY_IDS.ALL;
